import { getMainPageData, getPickWindow } from '@severed-links/common.redherrings-reducers/terminator'
import * as s from './Menu.scss'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { Nav } from 'react-bootstrap'
import { img } from '@severed-links/common.redherrings-constants'
import { getMe } from '@severed-links/common.redherrings-reducers/account'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import BaseAuthenticatedMenu from './BaseAuthenticatedMenu'

const TerminatorMenu = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const isAdmin = roles => roles.includes('TerminatorAdmin') && pathname.startsWith('/terminator/admin')
  const isAuthenticated = useSelector(state => state.account.isAuthenticated)
  useEffect(() => {
    if (isAuthenticated) dispatch(getMe())
  }, [dispatch, isAuthenticated])
  const state = useSelector(state => state.terminator)
  const [now, setNow] = useState(Date.now())
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [])
  useEffect(() => {
    if (isAuthenticated) dispatch(getMainPageData())
  }, [dispatch, isAuthenticated, pathname])
  const season = state.seasonName ? encodeURIComponent(state.seasonName) : ''
  const scoreboardWeek = state.seasonMode === 'Postseason' ? `playoff-week/${state.playoffWeek}` : `week/${state.week}`
  const { canEnterPick } = getPickWindow(state, now)
  const roles = useSelector(state => state.account.roles || [])
  const items = isAdmin(roles) ? [
    ['Back to Terminator', '/terminator'],
    ...(pathname.replace(/\/$/, '') === '/terminator/admin' ? [] : [['Dashboard', '/terminator/admin']]),
  ] : [
    ...(season && canEnterPick ? [['Enter pick', '/terminator/enter-pick']] : []),
    ...(season ? [['Standings', `/terminator/standings/${season}`]] : []),
    ...(season && (state.seasonMode === 'Postseason' ? state.playoffWeek : state.week) ? [['NFL Scoreboard', `/terminator/nfl-scoreboard/${season}/${scoreboardWeek}`]] : []),
    ['Winners', '/terminator/winners'],
    ...(roles.includes('TerminatorAdmin') ? [['Admin', '/terminator/admin']] : []),
  ]
  const menuItems = items.map(([title, path]) =>
    <Nav.Item className={s.item} key={path}><Nav.Link title={title} aria-label={title} onClick={() => navigate(path)}>{isAdmin(roles) ? <FontAwesomeIcon name={path === '/terminator' ? 'chevron-left' : 'home'} /> : title}</Nav.Link></Nav.Item>)
  return <BaseAuthenticatedMenu backgroundImageUrl={`${img.CloudinaryBaseUrl}v1789410346/terminator/header_terminator_back.png`}
    navbarBrand={<Link to={isAdmin(roles) ? '/terminator/admin' : '/terminator'}><img src={`${img.CloudinaryBaseUrl}e_trim/terminator/header_terminator_text.png`} height='30' alt='Terminator' /></Link>} menuItems={menuItems} />
}
export default TerminatorMenu
